module.exports = __webpack_public_path__ + "img/green_145.68a5a2a9.png";